import React, { Component } from 'react';
import Charts from './Charts';
import API_URL from '../../../../../common/url';

const QueryUrl = API_URL.requestDataAnalysis.queryUnregisteredContractCount;
const ExportUrl = API_URL.requestDataAnalysis.exportUnregisteredContract;

class HistogramBrokenLine extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { clientHeight, searchParams } = this.props;
        const height = clientHeight - 72;
        return (
            <div className="pane-item-content">
                <Charts
                    height={height}
                    filename="未登记请款的合同记录"
                    searchParams={searchParams}
                    queryUrl={QueryUrl}
                    exportUrl={ExportUrl}
                />
            </div>
        );
    }
}

export default HistogramBrokenLine;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/UnregisterRequest/HistogramBrokenLine/index.js